'use strict';
var MBX_EXTENSION = window.mockplus ? '.mbx' : '.xml';
var MPK_EXTENSION = window.mockplus ? '.mpk' : '.xml';

var LoadMethod;
if (window.zip) {
  LoadMethod = 'zip'; // 加载整个 mp 文件
} else if (window.enterprise) {
  LoadMethod = 'enterprise';
  MBX_EXTENSION = ".mbx";
  MPK_EXTENSION = ".mpk";
} else if (window.remote) {
  LoadMethod = 'remote'; // 异步加载
} else if (window.mockplus) {
  LoadMethod = 'mockplus'; // Mockplus 自用, 这种情况下, 资源文件从根目录下读取
} else {
  LoadMethod = 'dom'; // 从页面上获取数据
}

/**
 * 是从 zip 中读取数据
 * @returns {boolean}
 */
exports.isLoadFromZip = function () {
  return LoadMethod === 'zip';
};

var _isLoadFromEnterprise = function () {
  return LoadMethod === 'enterprise';
};

exports.isLoadFromEnterprise = _isLoadFromEnterprise;

exports.getMBXExtension = function () {
  return MBX_EXTENSION;
};

exports.getMPKExtension = function () {
  return MPK_EXTENSION;
};

exports.isLoadFromRemote = function () {
  return window.remote;
};

exports.isLoadFromMockplus = function () {
  return LoadMethod === 'remote';
};

exports.isEnterprise = function () {
  return window.enterprise;
};

exports.canReview = function () {
  var host = window.location.host;
  return ['localhost:3000', 'run.mockplus.cn', 'run.mockplus.com', 'jprun.mockplus.com'].indexOf(host) !== -1;
};



// WEBPACK FOOTER //
// ./src/helper/runtimeHelper.js